import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { AlertProvider } from './context/AlertContext';
import ProtectedRoute from './components/ProtectedRoute';
import AuthPage from './views/AuthPage';
import Dashboard from './views/Dashboard';
import { useEffect } from 'react';
import './App.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
    const location = useLocation();

    useEffect(() => {
        console.log('Route changed to:', location.pathname);

        // Optional: Scroll to top on route change
        window.scrollTo(0, 0);
    }, [location]);

    return (
        <AuthProvider>
            <AlertProvider>
                <div className="App">
                    <Routes>
                        {/* Public routes */}
                        <Route path="/login" element={<AuthPage />} />
                        <Route path="/forgot-password" element={<AuthPage />} />
                        <Route path="/request-access" element={<AuthPage />} />

                        {/* Protected routes */}
                        <Route element={<ProtectedRoute />}>
                            <Route path="/dashboard/*" element={<Dashboard />} />
                        </Route>

                        {/* Redirects */}
                        <Route path="/" element={<Navigate to="/dashboard" replace />} />
                        <Route path="*" element={<Navigate to="/login" replace />} />
                    </Routes>

                    {/* ToastContainer should be at the root level */}
                    <ToastContainer
                        position="top-center"
                        autoClose={5000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="colored"
                    />
                </div>
            </AlertProvider>
        </AuthProvider>
    );
}

export default App;